'use client';
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { PAGE_TYPES } from '@/app/constants';
import VisibilityTracker from '@/app/ui/components/tracking/visibilityTracker';
import { trackSSTEvent } from '@/app/utils/tracking';

export function BreadcrumbsMobile({
  breadcrumbs,
  title,
  pageType,
}: {
  breadcrumbs: { name: string; url: string }[];
  title?: string;
  pageType?: PAGE_TYPES;
}) {
  const penultimateBreadcrumb = breadcrumbs[breadcrumbs.length - 2];

  if (!penultimateBreadcrumb) {
    return null;
  }

  const clickEvents = () => {
    if (!pageType) return;
    const eventName = pageType === PAGE_TYPES.LIST ? 'plp_breadcrumbs_click' : 'pdp_breadcrumbs_click';
    trackSSTEvent(eventName, null);
  };

  return (
    <div className="d-flex mb-2">
      <Link
        href={penultimateBreadcrumb.url}
        className="text-black me-3 d-flex align-items-center text-decoration-none"
        onClick={clickEvents}>
        <Image src="/intstatic/icons/chevron-left.png" alt={'back-image'} width={10} height={17}></Image>
        <h1 className="main-headline m-0 ps-3">{title}</h1>
      </Link>
      {pageType && (
        <VisibilityTracker
          eventName={pageType === PAGE_TYPES.LIST ? 'plp_breadcrumbs_display' : 'pdp_breadcrumbs_display'}
          data={null}
        />
      )}
    </div>
  );
}
